document.addEventListener('turbolinks:load', function () {
    if ($('.projects.new, .projects.create, .projects.edit, .projects.update').length === 0) {
        return false
    }

    // scope only to v1 projects
    if ($('.permit_applications-form-section').length !== 0) {
        return false
    }

    var otherPermitField = $('#permitInformationTab .other-permit-field')
    var otherPermitCheckbox = $('#permitInformationTab #type_Other')

    toggleOtherPermitField()

    $(document).off('change', '#permitInformationTab #type_Other').on('change', '#permitInformationTab #type_Other', function () {
        toggleOtherPermitField()
        if (!otherPermitCheckbox.is(':checked')) {
            $('#project_other_permit').val('')
        }
    })

    function toggleOtherPermitField() {
        otherPermitField.toggleClass('d-none', !otherPermitCheckbox.is(':checked'))
    }
});
